export default function ViewIcon({ className, ...rest }) {
  // 475467
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M14.3628 5.3635C14.5655 5.6475 14.6668 5.79016 14.6668 6.00016C14.6668 6.21083 14.5655 6.35283 14.3628 6.63683C13.4522 7.91416 11.1262 10.6668 8.00016 10.6668C4.8735 10.6668 2.54816 7.9135 1.6375 6.63683C1.43483 6.35283 1.3335 6.21016 1.3335 6.00016C1.3335 5.7895 1.43483 5.6475 1.6375 5.3635C2.54816 4.08616 4.87416 1.3335 8.00016 1.3335C11.1268 1.3335 13.4522 4.08683 14.3628 5.3635Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4C7.46957 4 6.96086 4.21071 6.58579 4.58579C6.21071 4.96086 6 5.46957 6 6C6 6.53043 6.21071 7.03914 6.58579 7.41421C6.96086 7.78929 7.46957 8 8 8C8.53043 8 9.03914 7.78929 9.41421 7.41421C9.78929 7.03914 10 6.53043 10 6Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
